import { Component } from '@angular/core';
import { Overlay } from "./../commonMap/overlay";

@Component({
    moduleId: module.id,
    selector: 's144g-s144m01',
    templateUrl: './s144g-s144m01.component.html'
})
export class S144gS144m01Component extends Overlay {
    scrndt: any = {};
    scrntm: any = {};
    origin: any = {'value': '___'};
    destin: any = {'value': '___'};
    mvorig: any = {'value': '___'};
    mvdest: any = {'value': '___'};
    status: any = {'value': '_'};
    msgln: any = {};

    public FIELDS: string[] = ['scrndt', 'scrntm', 'origin', 'destin', 'mvorig', 'mvdest', 'status', 'msgln'];
    public LINES: number[] = [1, 2, 3, 6, 22, 7, 24, 9, 11, 13];

    ngAfterViewInit(): void {
    }
}
